import { Card, CardHeader, PageHeader } from '@minisoc/ui';

/**
 * Onglet Recommandations (hardening).
 *
 * Fonctionnalité planifiée en phase 2 du cahier des charges (§13.2), car elle
 * dépend du module Wazuh SCA sur les nœuds clients, hors périmètre de cette
 * itération. La page annonce explicitement ce qui n'existe pas encore plutôt que
 * d'afficher un score de conformité fabriqué : un faux indicateur de sécurité
 * est plus nuisible qu'une absence d'indicateur.
 */
export function RecommendationsPage() {
  return (
    <>
      <PageHeader
        title="Recommandations"
        subtitle="Durcissement de votre parc, basé sur l'évaluation de configuration Wazuh SCA"
      />

      <Card className="max-w-2xl">
        <CardHeader title="Module en cours de déploiement" />
        <div className="space-y-4 px-5 py-5 text-sm leading-relaxed text-text-muted">
          <p>
            Cet onglet présentera le score de conformité de chaque machine de votre parc, les
            faiblesses de configuration détectées et les actions correctives priorisées.
          </p>

          <div>
            <p className="label-caps">Ce que ce module apportera</p>
            <ul className="mt-2 space-y-1.5">
              {[
                'Score de conformité par machine, basé sur les référentiels CIS Benchmark',
                'Faiblesses détectées avec leur criticité et la correction associée',
                'Évolution du score dans le temps, pour objectiver les progrès',
                'Rapport mensuel de durcissement adressé automatiquement à votre contact',
              ].map((item) => (
                <li key={item} className="flex gap-2">
                  <span className="text-brand-500" aria-hidden="true">
                    →
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <p className="rounded-lg border border-border-subtle bg-surface-sunken px-4 py-3">
            Prérequis : activation du module SCA sur le nœud Proxmox de votre site, réalisée par
            MiniSOC lors d'une intervention planifiée. Contactez votre interlocuteur pour connaître
            la date prévue sur votre contrat.
          </p>
        </div>
      </Card>
    </>
  );
}
